// The storefront product sort list, in the seller portal's wording (reference 2026-10-10).
// "Recommended" = the seller's featured products first, in their order, then newest.
export const RECOMMENDED = 'Recommended';

export const STOREFRONT_PRODUCT_SORTS = [
  RECOMMENDED,
  'Product (A–Z)',
  'Product (Z–A)',
  'Brand (A–Z)',
  'Brand (Z–A)',
  'Price (low to high)',
  'Price (high to low)',
];

// Search index (Meilisearch) sort per option; Recommended also sends use_featured_sort.
export const MEILI_PRODUCT_SORT = {
  [RECOMMENDED]: 'created_at:desc',
  'Product (A–Z)': 'title:asc',
  'Product (Z–A)': 'title:desc',
  'Brand (A–Z)': 'brand:asc',
  'Brand (Z–A)': 'brand:desc',
  'Price (low to high)': 'base_price:asc',
  'Price (high to low)': 'base_price:desc',
};

// Product-list API sort per option (brand and collection product lists).
export const API_PRODUCT_SORT = {
  [RECOMMENDED]: [{ fieldName: 'recommended', fieldOrder: 'ASC' }],
  'Product (A–Z)': [{ fieldName: 'title', fieldOrder: 'ASC' }],
  'Product (Z–A)': [{ fieldName: 'title', fieldOrder: 'DESC' }],
  'Price (low to high)': [{ fieldName: 'price_msrp', fieldOrder: 'ASC' }],
  'Price (high to low)': [{ fieldName: 'price_msrp', fieldOrder: 'DESC' }],
};
